// @ts-nocheck
import * as React from 'react';
import Box from '@mui/material/Box';
import {BorderLinearProgress} from "./BarraDeCarga";


/**
 *
 * @param progress Entero entre 1 y 100 que indica lo cargada que esta la barra
 * @returns {JSX.Element}
 * @constructor
 *
 * Por fuera, hay que setear el complete a true para que la barra se llene al maximo, sino se queda al 90%
 */
export default function BarraDeLimite({progress,sx}) {

    return (

        <Box sx={sx}>
            <BorderLinearProgress variant="determinate" value={progress}/>
        </Box>

    );
}